import { useGetRolodexEntriesByLoadOptions } from 'features/rolodex'
import { useMemo } from 'react'
import {
  KnowledgeDocumentEntry,
  RolodexEntryType,
  SystemDocumentEntry,
} from 'types'

export const useKnowledgeDocumentsData = (
  siteID: string | undefined,
  unitID: string | undefined
) => {
  const {
    data: knowledgeDocuments,
    isLoading,
    mutate: refreshKnowledgeDocuments,
  } = useGetRolodexEntriesByLoadOptions<KnowledgeDocumentEntry[]>({
    type: [RolodexEntryType.KNOWLEDGE_DOCUMENT],
    tags: { site: siteID ?? 'zero', unit: unitID ?? 'zero' },
    limit: 10000,
  })

  const systemDocumentIds = useMemo(() => {
    return (
      knowledgeDocuments?.map(
        (document) => document.entry.tags['system-document']
      ) ?? []
    )
  }, [knowledgeDocuments])

  const { data: systemDocuments, isLoading: isReportsLoading } =
    useGetRolodexEntriesByLoadOptions<SystemDocumentEntry[]>({
      type: [RolodexEntryType.SYSTEM_DOCUMENT],
      ids: systemDocumentIds,
      tags: { site: siteID ?? 'zero', unit: unitID ?? 'zero' },
      limit: 10000,
    })

  return useMemo(() => {
    return {
      knowledgeDocuments,
      isLoading,
      refreshKnowledgeDocuments,
      systemDocuments,
      isReportsLoading,
    }
  }, [
    knowledgeDocuments,
    isLoading,
    refreshKnowledgeDocuments,
    systemDocuments,
    isReportsLoading,
  ])
}
